import { render, staticRenderFns } from "./YourAccount.vue?vue&type=template&id=46b23e43&scoped=true&"
import script from "./YourAccount.vue?vue&type=script&lang=ts&"
export * from "./YourAccount.vue?vue&type=script&lang=ts&"
import style0 from "./YourAccount.vue?vue&type=style&index=0&id=46b23e43&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b23e43",
  null
  
)

export default component.exports